//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CONNECTOR_TYPES } from '@/utils/constant';
import condition from './condition.vue';
export default {
  name: 'DataFilter',
  components: {
    condition,
  },
  props: {
    rules: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      },
    },
    appid: {
      type: Number,
      default: 0,
    },
    roles: {
      type: [Array, null],
      default: () => {
        return null;
      },
    },
    posts: {
      type: [Array, null],
      default: () => {
        return null;
      },
    },
    externalParam: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CONNECTOR_TYPES,
      flag: true,
      rule: false,
      ROLE_LIST: [], // 角色选项
      POST_LIST: [], // 岗位选项
    };
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(value) {
        this.save(value);
      },
    },
  },
  watch: {
    appid() {
      this.getRoleOptions();
      this.getPostOptions();
    },
  },
  created() {
    this.getRoleOptions();
    this.getPostOptions();
  },
  methods: {
    // 必填验证
    validate(cb) {
      //   this.rule = true; // 红框显示
      this.flag = true;
      this.mapMoListArr(this.value);
      if (!this.flag) {
        this.$message({
          message: '请完整填写条件信息',
          type: 'warning',
        });
      }
      cb(this.flag);
      return this.flag;
    },
    mapMoListArr({ conditions }) {
      for (const key in conditions) {
        const item = conditions[key];
        if (conditions[key].expression) {
          // 数组
          this.mapMoListArr(conditions[key].expression);
        } else {
          // 单条数据
          if (['EXIST', 'NOT_EXIST']) {
            if ([item.operation, item.value.type, item.value.value].includes('')) {
              this.flag = false;
              return false;
            }
          } else {
            if ([item.field, item.operation, item.value.type, item.value.value].includes('')) {
              this.flag = false;
              return false;
            }
          }
        }
      }
    },
    save(data) {
      this.$emit('input', data);
    },
    addCondition() {
      this.data = {
        ...this.data,
        conditions: [
          ...this.data.conditions,
          {
            expression: {
              connector: 'AND',
              conditions: [],
            },
          },
        ],
      };
    },
    addItem() {
      this.data = {
        ...this.data,
        conditions: [
          ...this.data.conditions,
          {
            field: '',
            operation: '',
            value: {
              type: '',
              value: '',
            },
          },
        ],
      };
    },
    delItem(number) {
      this.data = {
        ...this.data,
        conditions: this.data.conditions.filter((item, index) => {
          return number !== index;
        }),
      };
      // console.log(this.data.conditions[number]);
    },
    conditionChange(val, index) {
      const newdata = JSON.parse(JSON.stringify(this.data));
      newdata.conditions[index] = val;
      this.data = newdata;
    },
    // ---获取选项---
    // 角色
    async getRoleOptions() {
      if (this.roles) {
        this.ROLE_LIST = this.roles;
        return;
      }
      try {
        const { data } = await this.$request({
          url: this.$api.getRoleList,
          data: {
            appid: this.appid,
            page_size: 99999,
          },
        });
        this.ROLE_LIST = data;
      } catch (err) {
        console.log(err);
      }
    },
    // 岗位
    async getPostOptions() {
      if (this.posts) {
        this.POST_LIST = this.posts;
        return;
      }
      try {
        const { data } = await this.$request({
          url: this.$api.getJobList,
          data: {
            appid: this.appid,
            page_size: 99999,
          },
        });
        this.POST_LIST = data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
